import './CancelInboundModal.scss'

import React, { Component } from 'react'
import { connectModal } from 'redux-modal'
import { Modal } from 'react-bootstrap'

import {
    cancelBrokerInbound
  } from 'broker/redux/account'

class CancelInbound extends Component {
  constructor(props) {
    super(props)
    this.handleFinish = this.handleFinish.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
  }

  invite = this.props.invite

  handleFinish = () => {
    const { handleHide } = this.props

    handleHide()
  }

  handleCancel = () => {
    const { broker_inbound_hash } = this.invite

    this.props.dispatch(cancelBrokerInbound(broker_inbound_hash))
    .then(this.props.handleHide())
  }

  render() {
    const { show } = this.props

    return (
      <Modal className="CancelInboundModal" show={show}>
          <Modal.Header className="CancelInboundModal__header">
              <Modal.Title className="CancelInboundModal__header__title">
                  <div className="CancelInboundModal__header__title--text">Cancel Invite</div>
                  <div className="CancelInboundModal__header__title--close" onClick={this.handleFinish}/>
              </Modal.Title>
          </Modal.Header>

          <Modal.Body className="CancelInboundModal__body">
            <div className="CancelInboundModal__body--cancel-instructions">Are you sure you want to cancel this invite?</div> 
          </Modal.Body>

          <Modal.Footer className="CancelInboundModal__footer">
          <div className="CancelInboundModal__footer--left">
              <button id="finish-button" onClick={this.handleFinish}>Go Back</button>
            </div>
            <div className="CancelInboundModal__footer--right">
              <button id="cancel-invites-button" onClick={this.handleCancel}>Cancel Invite</button>
            </div>
          </Modal.Footer>
      </Modal>
    )
  }
}

const CancelInboundModal = connectModal({ name: 'CancelInboundModal', destroyOnHide: true })(CancelInbound)

export default CancelInboundModal
